import React, { useEffect } from "react";
import { Link, useLocation } from "@reach/router";
import { Col, Container, Row, Button } from "react-bootstrap";

import CourseList from "components/CourseList";
import { useAppContext, RouteContext } from "libs/contextLib";
import axiosObj from "libs/axios";

import { COMMON_ERROR } from "constants/common";
import { TEACHER_URLS } from "constants/urls";

import "./teacher-home.scss";
import * as CONSTANTS from "./constants";
import TEACH_BANNER from "assets/images/trainers-app-screen.png";

function TeacherHome(props) {
  const {
    authenticatedUser,
    authenticateUser,
    updateErrorMessage,
  } = useAppContext();
  const location = useLocation();

  useEffect(() => {
    if (authenticatedUser && authenticatedUser.teacher !== undefined) return;
    axiosObj
      .get(TEACHER_URLS.PROFILE)
      .then(
        (response) => {
          if (response.status === 200)
            authenticateUser({ ...authenticatedUser, teacher: response.data });
        },
        (onerror) => {
          if (onerror.response.status === 403)
            authenticateUser({ ...authenticatedUser, teacher: null });
          else if (onerror.response.status === 401) authenticateUser(null);
          else updateErrorMessage(COMMON_ERROR);
        }
      )
      .catch(function (error) {
        // TODO
      });
  }, [authenticatedUser, authenticateUser, updateErrorMessage]);

  let message;
  if (!authenticatedUser) {
    message = (
      <div>
        <Link to={"/login?redirect=" + location.pathname}>
          <Button size="lg" className="teach-home-apply-button">
            <div className="teach-home-login-signup">
              Login <span className="teach-home-or">or</span> Signup
            </div>
          </Button>
        </Link>{" "}
      </div>
    );
  } else if (authenticatedUser.teacher === undefined) {
    message = <></>;
  } else if (authenticatedUser.teacher === null) {
    message = (
      <Link to="apply">
        <Button size="lg" className="teach-home-apply-button">
          Register
        </Button>
      </Link>
    );
  } else if (!authenticatedUser.teacher.isEnabled) {
    message = (
      <div className="teach-home-message-box border rounded">
        Hold tight, we've got your request and will reach out to you soon.
      </div>
    );
  }

  return (
    // Providing domain to all child components since most of them are shared between teach and learn
    // Providing navigate (passed as props by Reach router) to child components to allow relative navigation
    <RouteContext.Provider
      value={{ domain: "teach", navigate: props.navigate }}
    >
      {message ? (
        <Container className="teach-home-without-courses">
          <Row className="mt-5">
            <Col md={6} xs={12} className="pr-md-5 teach-home-banner">
              <img
                alt="banner-for-teacher"
                src={TEACH_BANNER}
                style={{
                  objectFit: "contain",
                  width: "100%",
                  height: "100%",
                  borderRadius: "2%",
                }}
              />
            </Col>

            <Col md={6} xs={12} className="align-self-center">
              <Row>
                <Col xs={12} className="mb-2 teach-home-heading">
                  <h2>{CONSTANTS.TEACH_HEADING}</h2>
                </Col>
                <Col xs={12} className="text-muted teach-home-description">
                  <p>{CONSTANTS.TEACH_DESC}</p>
                </Col>
                <Col>{message}</Col>
              </Row>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container className="teach-home-with-courses">
          <Row className="mt-4 mx-1">
            <Col className="teach-home-heading">Your courses</Col>
          </Row>
          <CourseList for="teacher" />
        </Container>
      )}
    </RouteContext.Provider>
  );
}

export default TeacherHome;
